<div class="modal-dialog-alert" role="document">
    <div class="modal-content v-card card modal-card">
        <div class="modal-header d-flex align-items-center">
            <div class="modal-title font-weight-600">{{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.TITLE' | translate }}</div>
            <div class="cursor-pointer"  (click)="close()">
                <img src="assets/img/close_white.svg" alt="">

            </div>
        </div>
        <div class="modal-body d-flex flex-column align-items-center" style="position: relative;">
            <p>{{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.MESSAGE' | translate }}</p>
        </div>

        <div class="d-flex mb-5 top-gap-30 justify-content-center">
            <button type="button" class="v-btn vsight-button left btn vsight-button-outline-secondary btn-secondary font-weight-600 me-1" (click)="deny()">
                {{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.DENY' | translate }}
            </button>
            <button type="button" class="v-btn btn vsight-button btn-primary create-button" (click)="allow()">
                {{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.ALLOW' | translate }}
            </button>
        </div>
    </div>
</div>